import React, { useEffect, useContext } from 'react';
import { MsalContext } from '@azure/msal-react';
import { useAuthStore } from '../stores/authStore';

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const context = useContext(MsalContext);
  const { initializeAuthentication } = useAuthStore();

  useEffect(() => {
    initializeAuthentication({
      instance: context.instance,
      accounts: context.accounts,
      inProgress: context.inProgress,
    });
  }, [context.instance, context.accounts, context.inProgress, initializeAuthentication]);

  return <>{children}</>;
};

export default AuthProvider;
